onComplete(function () {
	// Add code here.
	var pageScroll = 100;

	$(window).scroll(function () {
		var scroll = getCurrentScroll();
		if (scroll >= pageScroll) {
			$('.nav-header').addClass('scroll');
		} else {
			$('.nav-header').removeClass('scroll');
		}
	});

	function getCurrentScroll () {
		return window.pageYOffset || document.documentElement.scrollTop;
	}
});